// import './Footer.css';
import React from "react";
import { Link } from 'react-router-dom';


function Connect(props) {
    return (
        <div className="">
            <Link className="link" to="/" >
                <p className="backButton"> back to home </p>
            </Link>
           <h1 className="storyHeaderText"> CONNECT WITH US </h1>
        </div>
    )
}

export default Connect;